interface IPagination {
    total_count: number,
    next_offset: number,
}

export class Pagination {
    public total: number = 0;
    public offset: number = 0;
    public page: number = 1;
    public totalPages: number = 0;
    public pagesArray: number[];

    constructor(pagination: IPagination = { total_count: 0, next_offset: 20 }, public limit: number = 20) {
        this.total = pagination.total_count;
        this.offset = pagination.next_offset;

        this.page = Math.ceil(this.offset / this.limit);
        this.totalPages = Math.ceil(this.total / this.limit);
        this.fillPagesArray();
    }

    public setPage(page: number) {
        this.offset = this.limit * (page - 1);
        this.page = page;
        this.fillPagesArray();
        return true;
    }

    public nextPage() {
        this.setPage(this.page++)
    }

    public prevPage() {
        this.setPage(this.page--)
    }

    private fillPagesArray () {
        this.pagesArray = [];
        this.pagesArray.push(this.page);

        var pushedPagesLeft = 3;
        var unshiftedPagesLeft = 3;
        var unshiftedPage = this.page - 1;
        var pushedPage = this.page + 1;

        if (this.page > this.totalPages/2) {
            while (pushedPage <= this.totalPages && pushedPagesLeft > 0) {
                this.pagesArray.push(pushedPage);
                pushedPage++;
                pushedPagesLeft--;
            }
            unshiftedPagesLeft += pushedPagesLeft;

            while (unshiftedPage > 0 && unshiftedPagesLeft > 0) {
                this.pagesArray.unshift(unshiftedPage);
                unshiftedPage--;
                unshiftedPagesLeft--;
            }


        } else {
            while (unshiftedPage > 0 && unshiftedPagesLeft > 0) {
                this.pagesArray.unshift(unshiftedPage);
                unshiftedPage--;
                unshiftedPagesLeft--;
            }
            pushedPagesLeft += unshiftedPagesLeft;

            while (pushedPage <= this.totalPages && pushedPagesLeft > 0) {
                this.pagesArray.push(pushedPage);
                pushedPage++;
                pushedPagesLeft--;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/Pagination.ts